/**
 * @file
 * @author gaoya10
 */
import Breadcrumb from './Breadcrumb';
export default Breadcrumb;
